import { render, staticRenderFns } from "./PasswordPolicyGrid.vue?vue&type=template&id=36db6e37"
import script from "./PasswordPolicyGrid.vue?vue&type=script&lang=js"
export * from "./PasswordPolicyGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports